module.exports = __webpack_public_path__ + "static/media/HalfCircle.492c634d.svg";